import React from 'react';
import PropTypes from 'prop-types';
import {
    colors, fontSizes, lineHeights, fontWeights, space
} from 'style/config';
import { wrapFunctionalComponent } from 'utils/framework';
import helperUtils from 'utils/Helpers';
import { Flex, Text, Icon } from 'components/ui';

const { capitalizeFirstLetter } = helperUtils;

/**
 * Header section for a SubscriptionItem showing delivery frequency (active)
 * or paused-state savings messaging (paused).
 */
function Header({
    subscription, subscriptionData, hotDealData, localization, firstName, product
}) {
    return (
        <Flex css={styles.header}>
            <Icon
                css={styles.icon}
                name='autoReplenish'
            />
            <Text
                css={styles.heading}
                is='h2'
            >
                {subscriptionData.isActive ? (
                    `${localization.deliverEvery} ${subscription.frequency} ${subscriptionData.frequencyDelivery}`
                ) : (
                    <>
                        {localization.paused}
                        <Text
                            is='span'
                            css={styles.subheading}
                        >
                            {`${capitalizeFirstLetter(firstName)}, ${product.acceleratedPromotion ? localization.stillSave : localization.save} `}
                            <Text
                                is='span'
                                css={styles.highlight}
                            >
                                {`${product.acceleratedPromotion ? product.acceleratedPromotion.remainingAcceleratedDiscount : product.yearlySavings} `}
                            </Text>
                            {product.acceleratedPromotion
                                ? `${localization.before} ${hotDealData.transformedPromoExpiryDate ?? ''}.`
                                : localization.annuallyWithSubscription}
                        </Text>
                    </>
                )}
            </Text>
        </Flex>
    );
}

const styles = {
    header: {
        alignItems: 'center',
        paddingTop: space[3]
    },
    icon: {
        verticalAlign: 'middle',
        marginRight: space[3]
    },
    heading: {
        fontSize: fontSizes.md,
        fontWeight: fontWeights.bold,
        lineHeight: lineHeights.tight
    },
    subheading: {
        display: 'block',
        fontWeight: fontWeights.normal,
        whiteSpace: 'nowrap'
    },
    highlight: {
        color: colors.red,
        fontWeight: fontWeights.bold
    }
};

Header.propTypes = {
    subscription: PropTypes.shape({
        frequency: PropTypes.number
    }).isRequired,
    subscriptionData: PropTypes.shape({
        isActive: PropTypes.bool,
        isPaused: PropTypes.bool,
        frequencyDelivery: PropTypes.string
    }).isRequired,
    hotDealData: PropTypes.shape({
        transformedPromoExpiryDate: PropTypes.string
    }).isRequired,
    localization: PropTypes.object.isRequired,
    firstName: PropTypes.string.isRequired,
    product: PropTypes.shape({
        acceleratedPromotion: PropTypes.object,
        yearlySavings: PropTypes.string
    }).isRequired
};

export default wrapFunctionalComponent(Header, 'Header');
